import React from 'react';
import { bool, func, string } from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { Modal, PrimaryButton, SecondaryButton } from '../../components';
import css from './ConfirmationModal.module.css';

const ConfirmationModalComponent = props => {
  const {
    id,
    intl,
    isOpen,
    onCloseModal,
    onManageDisableScrolling,
    onConfirm,
    confirmInProgress,
    confirmError,
    titleId,
    messageId,
    confirmTextId,
    cancelTextId,
    errorMessageId,
  } = props;

  const handleConfirm = () => {
    onConfirm();
  };

  const errorMessage = confirmError ? (
    <p className={css.error}>
      <FormattedMessage id={errorMessageId} />
    </p>
  ) : null;

  return (
    <Modal
      id={id}
      containerClassName={css.modalContainer}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <div className={css.root}>
        <h2 className={css.title}>
          <FormattedMessage id={titleId} />
        </h2>
        <p className={css.message}>
          <FormattedMessage id={messageId} />
        </p>
        {errorMessage}
        <div className={css.buttonGroup}>
          <SecondaryButton
            className={css.cancelButton}
            onClick={onCloseModal}
            disabled={confirmInProgress}
          >
            <FormattedMessage id={cancelTextId} />
          </SecondaryButton>
          <PrimaryButton
            className={css.confirmButton}
            onClick={handleConfirm}
            inProgress={confirmInProgress}
            disabled={confirmInProgress}
          >
            <FormattedMessage id={confirmTextId} />
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationModalComponent.defaultProps = {
  confirmError: null,
  confirmInProgress: false,
  cancelTextId: 'ConfirmationModal.cancel',
  errorMessageId: 'ConfirmationModal.confirmError',
};

ConfirmationModalComponent.propTypes = {
  id: string.isRequired,
  intl: intlShape.isRequired,
  isOpen: bool.isRequired,
  onCloseModal: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onConfirm: func.isRequired,
  titleId: string.isRequired,
  messageId: string.isRequired,
  confirmTextId: string.isRequired,
  cancelTextId: string,
  errorMessageId: string,
  confirmInProgress: bool,
  confirmError: propTypes.error,
};

const ConfirmationModal = injectIntl(ConfirmationModalComponent);

export default ConfirmationModal;
